import { useContext, useEffect, useState } from 'react'
import { IObject, IResponse } from 'interfaces'
import { useFetch } from 'hooks'
import { UserContext } from 'context/userContext'
import {
  Loading,
  ShowDetails,
  DoclistHandle,
  UsersTable,
  Path,
  Toggle,
} from 'components'
import * as Sessions from 'components/Modal/Items'
import { GeneralContext } from 'context/generalContext'
import { moneyToNumber } from 'helper/utils'
import { Container } from './style'
import User from '../Components/User'
import ModalHeader from '../Components/ModalHeader'

const statusOptions = [
  {
    label: 'Em negociação',
    value: 0,
  },
  {
    label: 'Contrato solicitado',
    value: 1,
  },
  {
    label: 'Contrato em criação',
    value: 2,
  },
  {
    label: 'Contrato em negociação',
    value: 3,
  },
  {
    label: 'Aguardando assinatura',
    value: 4,
  },
  {
    label: 'Contrato assinado',
    value: 5,
  },
  {
    label: 'Aguardando pagamento',
    value: 6,
  },
  {
    label: 'Pagamento realizado',
    value: 7,
  },
]

export default function DetalhesJuridico() {
  const { selectedId, loading, setLoading } = useContext(UserContext)
  const [data, setData] = useState<any>({})
  const [showDetails, setShowDetails] = useState<boolean>(false)
  // const [previousId, setPreviousId] = useState<any>('')
  const [toggle, setToggle] = useState<string>('current')
  const [previusData, setPreviusData] = useState<any>({})
  const [originalData, setOriginalData] = useState<any>({})
  const api = useFetch(`/gestor/contract?id=${selectedId.current}`)

  const fetchData = async (url: string) => {
    try {
      setLoading(true)
      const response: IResponse = await api.fetch('get', null, url)
      // console.log(response)
      if (response.fail) throw new Error(response.errors.message)
      const info = response.data.data
      const { enterpriseId } = info.token
      info.documentList = []
      switch (info?.token?.holderList?.length) {
        case 0:
          info.capType = 'Aberta'
          break
        case 1:
          info.capType = 'Personalizada Individual'
          break
        default:
          info.capType = 'Personalizada em Grupo'
      }
      info.account = await api
        .fetch('get', null, `/gestor/account?id=${info.accountId}`)
        .then((r: IResponse) => r.data.data)

      info.enterprise = await api
        .fetch('get', null, `/gestor/enterprise?id=${enterpriseId}`)
        .then((r: IResponse) => r.data.data)

      // Fill documents
      ;['contract', 'document'].forEach((type: string) => {
        ;['enterprise', 'contract'].forEach((source) => {
          info[source][`${type}List`]?.forEach((c: IObject) => {
            info.documentList.push({
              name: c.type,
              file: c.file,
              type,
              status: c.status,
            })
          })
        })
      })

      console.log(info)
      return info

      // setData(info)
      // console.log(`dados modal de detalhe`, info)
      // if (toggle === 'current') {
      //   setPreviousId(info.contract?.customData?.sourceId)
      // }
    } catch (err: any) {
      console.log('err', err)
      setLoading(false)
    }
  }

  useEffect(() => {
    const setInicial = async () => {
      const r = await fetchData(`/gestor/contract?id=${selectedId.current}`)
      setOriginalData(r)
      setData(r)
      setLoading(false)
      if (r?.contract?.customData?.sourceId) {
        const p = await fetchData(
          `/gestor/contract?id=${r.contract?.customData?.sourceId}`
        )
        setPreviusData(p)
        setLoading(false)
      }
    }

    setInicial()
  }, [])

  useEffect(() => {
    if (toggle === 'previous') {
      // fetchData(`/gestor/contract?id=${previousId}`)
      setData(previusData)
    } else {
      // fetchData(`/gestor/contract?id=${selectedId.current}`)
      setData(originalData)
    }
  }, [toggle])

  const toggleDisabled = [
    ['Contrato migrado', 'current', true],
    ['Contrato de origem', 'previous', true],
  ]
  const toggleOptionList = [
    ['Contrato migrado', 'current', false],
    ['Contrato de origem', 'previous', false],
  ]

  const invested: any = moneyToNumber(data?.contract?.invested)

  if (loading) return <Loading modal />
  return (
    <Container>
      <Path className="path">
        <span className="path">{'Gestão de clientes > Fluxo comercial'}</span>
      </Path>

      {originalData?.contract?.customData?.sourceId && (
        <div style={{ width: 280, marginLeft: 5, marginBottom: 20 }}>
          <Toggle
            options={!loading ? toggleOptionList : toggleDisabled}
            toggle={toggle}
            setToggle={setToggle}
          />
        </div>
      )}
      <ModalHeader
        user={data?.account?.user}
        title={data?.token?.name}
        type={data?.capType}
        subtitle="Detalhes da captação"
        status={data?.contract?.status}
        statusOptions={statusOptions}
        tokenGestorId={data?.token?.gestorId}
        gestorId={data?.account?.account?.gestorId}
      />

      <div>
        <ShowDetails
          onClick={() => setShowDetails((oldValue) => !oldValue)}
          hidden={!showDetails}
        />
        {showDetails ? <User accountData={data} readonly /> : null}
      </div>
      <Sessions.Info token={data?.token} />
      <Sessions.Condition
        setData={setData}
        contractId={selectedId.current}
        token={data?.token}
        contract={data?.contract}
        enterprise={data?.enterprise}
      />
      <Sessions.Contract token={data?.token} contract={data?.contract} />
      <Sessions.Rental token={data?.token} />
      <Sessions.Dates
        isInvesment={invested > 0}
        token={data.token}
        data={data}
      />
      {/* {data?.token?.profitabilityBonus && ( */}
      {data?.bonus && <Sessions.Bonus data={data?.bonus} />}
      {/* )} */}
      <Sessions.Payments token={data?.token} contract={data?.contract} />
      <Sessions.Simula
        id={data?.token?.id}
        name={data?.enterprise?.name}
        value={data?.token?.expected}
        isInsento={data?.token?.IRType === 'Isento'}
      />
      {data?.token?.holderList?.length > 1 && (
        <UsersTable
          captationID="id"
          data={data?.token?.holderList}
          disableDelete
        />
      )}
      <h4 className="detalhes-captacao-subtitle">Anexos da captação</h4>
      <div className="detalhes-botoes-container">
        <DoclistHandle documentList={data?.documentList} readonly />
      </div>
      {/* <h4 className="detalhes-captacao-subtitle">Documentos</h4>
      <div className="detalhes-botoes-container">
        <DoclistHandle documentList={data?.enterprise?.documentList} readonly />
      </div> */}
    </Container>
  )
}
